import React, { Suspense, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getProductCardLabels, getView360State, } from '@yme/pdp-components/ProductCard/redux/selectors';
import { LoadingModel } from './LoadingModel';
import { View360Context } from './View360Context';
import { View360Control } from './View360Control';
import { View360ImagesList } from './View360ImagesList';
import { View360StaticImage } from './View360StaticImage';
import { VIEW_360_WRAPPER_TEST_ID } from './constants';
import { View360ContentStyled } from './styled';
import { use360View } from './use360View';
export function View360({ images, btnRef }) {
    const [imagesLoaderCounter, setImagesLoaderCounter] = useState(0);
    const { onTouchMove, onTouchStart, onMouseDown, currentImageIndex, isImagesLoading, setIsImagesLoading, isGuideShowing, } = use360View({
        images,
    });
    const view360State = useSelector(getView360State);
    const labels = useSelector(getProductCardLabels);
    const isView360GuideShowed = view360State && isImagesLoading && isGuideShowing;
    const isView360ButtonShowed = isImagesLoading || imagesLoaderCounter === 0;
    const imagesCounter = useMemo(() => ({
        imagesLoaderCounter,
        setImagesLoaderCounter,
    }), [imagesLoaderCounter]);
    const imagesLength = images.length;
    useEffect(() => {
        if (imagesLoaderCounter === imagesLength) {
            setIsImagesLoading(true);
        }
    }, [imagesLength, imagesLoaderCounter, setIsImagesLoading]);
    return (React.createElement(View360Control, { isView360GuideShowed: isView360GuideShowed, isView360ButtonShowed: isView360ButtonShowed, btnRef: btnRef, "data-testid": VIEW_360_WRAPPER_TEST_ID },
        React.createElement(View360Context.Provider, { value: imagesCounter },
            React.createElement(View360ContentStyled, null, view360State ? (React.createElement(Suspense, { fallback: React.createElement(LoadingModel, { label: labels.view360LoadingText, imagesLength: imagesLength }) },
                React.createElement(View360ImagesList, { images: images, onTouchMove: onTouchMove, onMouseDown: onMouseDown, onTouchStart: onTouchStart, currentImageIndex: currentImageIndex }))) : (React.createElement(View360StaticImage, { src: imagesLength ? images[0].url : '', altText: imagesLength ? images[0].label : '' }))))));
}
